var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTvNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2250027_box_cable_screen_set_television_icon_1",
    "data-name": "2250027_box_cable_screen_set_television_icon 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M170,85A85,85,0,1,1,85,0,85,85,0,0,1,170,85Z",
    transform: "translate(0)",
    fill: "#ffd301"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M161.626,122.062a85,85,0,1,0-153.252,0Z",
    transform: "translate(0 0.044)",
    fill: "#ff4867"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M11.349,0H124.843a11.309,11.309,0,0,1,11.349,11.269v64.8a11.309,11.309,0,0,1-11.349,11.269H11.349A11.309,11.309,0,0,1,0,76.067v-64.8A11.309,11.309,0,0,1,11.349,0Z",
    transform: "translate(16.904 54.159)",
    fill: "#4f5564"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M5.635,0H64.8a5.635,5.635,0,0,1,5.635,5.635V84.519A5.635,5.635,0,0,1,64.8,90.153H5.635A5.635,5.635,0,0,1,0,84.519V5.635A5.635,5.635,0,0,1,5.635,0Z",
    transform: "matrix(0, 1, -1, 0, 115.818, 62.586)",
    fill: "#25cec6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M2.817,0H56.346a2.817,2.817,0,0,1,2.817,2.817V76.067a2.817,2.817,0,0,1-2.817,2.817H2.817A2.817,2.817,0,0,1,0,76.067V2.817A2.817,2.817,0,0,1,2.817,0Z",
    transform: "matrix(0, 1, -1, 0, 110.205, 68.207)",
    fill: "#8de1de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M29.793,11.269A15.481,15.481,0,0,0,0,11.269Z",
    transform: "translate(54.501 42.517)",
    fill: "#454a57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M5.635,2.817A2.817,2.817,0,1,1,2.817,0,2.817,2.817,0,0,1,5.635,2.817Z",
    transform: "translate(39.674)",
    fill: "#454a57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-8",
    "data-name": "Vector",
    d: "M5.635,2.817A2.817,2.817,0,1,1,2.817,0,2.817,2.817,0,0,1,5.635,2.817Z",
    transform: "translate(93.518)",
    fill: "#454a57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-9",
    "data-name": "Vector",
    d: "M28.173,45.077,0,0",
    transform: "translate(42.548 2.817)",
    fill: "none",
    stroke: "#454a57",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-10",
    "data-name": "Vector",
    d: "M0,45.077,28.173,0",
    transform: "translate(68.077 2.817)",
    fill: "none",
    stroke: "#454a57",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-11",
    "data-name": "Vector",
    d: "M0,0H19.721",
    transform: "translate(124.923 65.167)",
    fill: "none",
    stroke: "#404551",
    strokeLinecap: "round",
    strokeWidth: 0.935
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-12",
    "data-name": "Vector",
    d: "M0,0H19.721",
    transform: "translate(124.923 70.833)",
    fill: "none",
    stroke: "#404551",
    strokeLinecap: "round",
    strokeWidth: 0.935
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-13",
    "data-name": "Vector",
    d: "M0,0H19.721",
    transform: "translate(124.923 76.5)",
    fill: "none",
    stroke: "#404551",
    strokeLinecap: "round",
    strokeWidth: 0.935
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-14",
    "data-name": "Vector",
    d: "M8.452,4.226A4.226,4.226,0,1,1,4.226,0,4.226,4.226,0,0,1,8.452,4.226Z",
    transform: "translate(130.372 96.362)",
    fill: "#f2572d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-15",
    "data-name": "Vector",
    d: "M8.452,4.226A4.226,4.226,0,1,1,4.226,0,4.226,4.226,0,0,1,8.452,4.226Z",
    transform: "translate(130.372 110.533)",
    fill: "#a0e48d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvNew);
export default __webpack_public_path__ + "static/media/tv-new.510dcc04dba354752da4ef8f665e506e.svg";
export { ForwardRef as ReactComponent };